const initialState = {
	success: '',
	error: ""
}

const deleteSaloonReducer = (state= initialState, action) => {
	switch(action.type) {
		case "FETCH_DELETE_REQUEST":
			return {...state}
		case "FETCH_DELETE_SUCCESS":	
			return {success: action.payload}
		case "FETCH_DELETE_FAILURE":	
			return {success: '', error: action.payload}
		default:
			return state
	}
}
export default deleteSaloonReducer